import domain from "./domain";
import { resetWorkspaceMembers } from "./events";
import { CollectionResource } from "dy-frontend-http-repository/lib/data/resources";
import { WorkspaceUserListItemResource } from "dy-frontend-http-repository/lib/modules/WorkspaceUser/resources";

export const $workspaceMembers = domain
    .createStore<CollectionResource<WorkspaceUserListItemResource, {}> | null>(null)
    .reset(resetWorkspaceMembers);
